import { I18n } from "@assets/strings";
import moment from "moment";
import React, { useState } from "react";
import styled from "styled-components";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { useShareroomAlias, useTransactionLists } from "@domain/wallet/hook";
import { TransactionFilterOptions } from "@domain/wallet/wallet";
import { useIsMobile } from "@utils/hooks";
import { ClosableModal } from "@ui/modals/closableModal";
import { mobile } from "@ui/styles/utils";
import { InfiniteScroll } from "@ui/components/infiniteScroll";
import { EmptyTable } from "@ui/components/wallet/EmptyTable";
import { TransactionsList } from "@ui/components/wallet/transactionsList";
import { TransactionsTable } from "@ui/components/wallet/transactionsTable";

interface SeeMoreTransactionModalProps extends React.HTMLAttributes<HTMLDivElement> {
	close: () => void;
}

export const SeemoreTransaction: React.FC<SeeMoreTransactionModalProps> = ({ close, ...htmlProps }) => {
	const currentProfile = useCurrentProfile();
	const currentLanguage = currentProfile?.language === "ENGLISH" ? "en" : "fr";
	const isMobile = useIsMobile();
	moment.locale(currentLanguage);
	const [filterOption] = useState<TransactionFilterOptions | undefined>(undefined);
	const shareroomAlias = useShareroomAlias();
	const {
		result: transactions,
		loading,
		fetchMore,
		totalElements,
	} = useTransactionLists(filterOption, shareroomAlias ?? undefined);
	return (
		<Container
			close={() => {
				close();
			}}
			{...htmlProps}
			isModalTransaction
		>
			<StyledHeader>
				<ContainerDescriptionHisto>
					<StyledTitle>{I18n.t("shareroom.dashboard.transactions.history.title")}</StyledTitle>
					<StyledDescription>{I18n.t("shareroom.dashboard.transactions.history.description")}</StyledDescription>
				</ContainerDescriptionHisto>
			</StyledHeader>
			{!totalElements && !loading ? (
				<EmptyTable />
			) : (
				<InfiniteScroll loading={loading} onEndReached={fetchMore}>
					{isMobile ? (
						<TransactionsList transactions={transactions} />
					) : (
						<TransactionsTable transactions={transactions} />
					)}
				</InfiniteScroll>
			)}
		</Container>
	);
};

const Container = styled(ClosableModal)`
	display: flex;
`;

const StyledHeader = styled.div`
	display: flex;
	flex-direction: row;
	margin-bottom: 30px;
`;

const ContainerDescriptionHisto = styled.div`
	margin-left: 30px;
	@media ${mobile} {
		margin-left: 0px;
	}
`;

const StyledTitle = styled.div`
	font-weight: 600;
	font-size: 20px;
	line-height: 26px;
	@media ${mobile} {
		font-size: 16px;
		line-height: 26px;
	}
`;

const StyledDescription = styled.div`
	font-weight: 400;
	font-size: 14px;
	line-height: 26px;
	@media ${mobile} {
		font-size: 10px;
		line-height: 26px;
	}
`;
